export const database = [
    
    {
        idUsuario: 2,
        usuario: 'Pedro Y',
        endereço: 'Marquês de Abrantes, 23',
        bairro: 'Flamengo',
        municipio: 'Rio de Janeiro',
        uf: 'RJ',
        locador: true,
        locatario: {
            ativo: true,
            carrosAnunciados: 
                {
                    ativo: true,
                    modelo: 'Voyage',
                    fotos:[
                        'https://img1.icarros.com/dbimg/imgadicionalnoticia/4/98279_1',
                        'https://img1.icarros.com/dbimg/imgadicionalnoticia/4/98277_1',
                        'https://img1.icarros.com/dbimg/imgadicionalnoticia/4/98274_1'
                    ],
                    combustivel: 'Gasolina',
                    arCondicionado: true,
                    quatroPortas: true,
                    preço: 120
                }
            
        }
    

    },
    {
        idUsuario: 3,
        usuario: 'Saul F',
        endereço: 'Armando Lombardi, 178',
        bairro: 'Barra da Tijuca',
        municipio: 'Rio de Janeiro',
        uf: 'RJ',
        locador: true,
        locatario: {
            ativo: true,
            carrosAnunciados: 
                {
                    ativo: true,
                    modelo: 'Voyage',
                    fotos:[
                        'https://img1.icarros.com/dbimg/imgadicionalnoticia/4/98279_1',
                        'https://img1.icarros.com/dbimg/imgadicionalnoticia/4/98277_1',
                        'https://img1.icarros.com/dbimg/imgadicionalnoticia/4/98274_1'
                    ],
                    combustivel: 'Gasolina',
                    arCondicionado: true,
                    quatroPortas: true,
                    preço: 120
                }
            
        }
    

    },
    {
        idUsuario: 4,
        usuario: 'Arlindo Cruz',
        endereço: 'Rua da Feira, 220',
        bairro: 'Bangu',
        municipio: 'Rio de Janeiro',
        uf: 'RJ',
        locador: false,
        locatario: {
            ativo: true,
            carrosAnunciados: 
                {
                    ativo: true,
                    modelo: 'Prius',
                    fotos:[
                        'https://t.ctcdn.com.br/kegH6NpugxZ_O5xb6a-pE1JVM4k=/1024x0/smart/i355194.jpeg',
                        'https://t.ctcdn.com.br/ntHgA_nvYEKjN2asWvpW79vG1-8=/1024x0/smart/i355195.jpeg',
                        'https://t.ctcdn.com.br/6ntpa6hoNjLBj1tVmlDiXTc0rpU=/1024x0/smart/i355198.jpeg'
                    ],
                    combustivel: 'Híbrido',
                    arCondicionado: true,
                    quatroPortas: true,
                    preço: 95
                }
            
        }
    

    },
    {
        idUsuario: 5,
        usuario: 'Marcelo M',
        endereço: 'Avenida Gláucio Gil, 1120',
        bairro: 'Recreio dos Bandeirantes',
        municipio: 'Rio de Janeiro',
        uf: 'RJ',
        locador: true,
        locatario: {
            ativo: true,
            carrosAnunciados: {
                ativo: true,
                modelo: 'Audi Q7',
                fotos:[
                    'https://quatrorodas.abril.com.br/wp-content/uploads/2019/06/audi-q7-2020-1600-02-e1561576093215.jpg',
                    'https://quatrorodas.abril.com.br/wp-content/uploads/2019/06/audi-q7-2020-1600-0b-e1561576634747.jpg',
                    'https://quatrorodas.abril.com.br/wp-content/uploads/2019/06/audi-q7-2020-1600-0c-e1561575930679.jpg'
                ],
                combustivel: 'Elétrico',
                arCondicionado: true,
                quatroPortas: true,
                preço: 230
            }
        }
    

    },
    {
        idUsuario: 2,
        usuario: 'Pedro Y',
        endereço: 'Marquês de Abrantes, 23',
        bairro: 'Flamengo',
        municipio: 'Rio de Janeiro',
        uf: 'RJ',
        locador: true,
        locatario: {
            ativo: true,
            carrosAnunciados: 
                {
                    ativo: true,
                    modelo: 'Voyage',
                    fotos:[
                        'https://img1.icarros.com/dbimg/imgadicionalnoticia/4/98279_1',
                        'https://img1.icarros.com/dbimg/imgadicionalnoticia/4/98277_1',
                        'https://img1.icarros.com/dbimg/imgadicionalnoticia/4/98274_1'
                    ],
                    combustivel: 'Gasolina',
                    arCondicionado: true,
                    quatroPortas: true,
                    preço: 120
                }
            
        }
    

    },
    {
        idUsuario: 3,
        usuario: 'Saul F',
        endereço: 'Armando Lombardi, 178',
        bairro: 'Barra da Tijuca',
        municipio: 'Rio de Janeiro',
        uf: 'RJ',
        locador: true,
        locatario: {
            ativo: true,
            carrosAnunciados: 
                {
                    ativo: true,
                    modelo: 'Voyage',
                    fotos:[
                        'https://img1.icarros.com/dbimg/imgadicionalnoticia/4/98279_1',
                        'https://img1.icarros.com/dbimg/imgadicionalnoticia/4/98277_1',
                        'https://img1.icarros.com/dbimg/imgadicionalnoticia/4/98274_1'
                    ],
                    combustivel: 'Gasolina',
                    arCondicionado: true,
                    quatroPortas: true,
                    preço: 120
                }
            
        }
    

    },
    {
        idUsuario: 4,
        usuario: 'Arlindo Cruz',
        endereço: 'Rua da Feira, 220',
        bairro: 'Bangu',
        municipio: 'Rio de Janeiro',
        uf: 'RJ',
        locador: false,
        locatario: {
            ativo: true,
            carrosAnunciados: 
                {
                    ativo: true,
                    modelo: 'Prius',
                    fotos:[
                        'https://t.ctcdn.com.br/kegH6NpugxZ_O5xb6a-pE1JVM4k=/1024x0/smart/i355194.jpeg',
                        'https://t.ctcdn.com.br/ntHgA_nvYEKjN2asWvpW79vG1-8=/1024x0/smart/i355195.jpeg',
                        'https://t.ctcdn.com.br/6ntpa6hoNjLBj1tVmlDiXTc0rpU=/1024x0/smart/i355198.jpeg'
                    ],
                    combustivel: 'Híbrido',
                    arCondicionado: true,
                    quatroPortas: true,
                    preço: 95
                }
            
        }
    

    },
    {
        idUsuario: 5,
        usuario: 'Marcelo M',
        endereço: 'Avenida Gláucio Gil, 1120',
        bairro: 'Recreio dos Bandeirantes',
        municipio: 'Rio de Janeiro',
        uf: 'RJ',
        locador: true,
        locatario: {
            ativo: true,
            carrosAnunciados: {
                ativo: true,
                modelo: 'Audi Q7',
                fotos:[
                    'https://quatrorodas.abril.com.br/wp-content/uploads/2019/06/audi-q7-2020-1600-02-e1561576093215.jpg',
                    'https://quatrorodas.abril.com.br/wp-content/uploads/2019/06/audi-q7-2020-1600-0b-e1561576634747.jpg',
                    'https://quatrorodas.abril.com.br/wp-content/uploads/2019/06/audi-q7-2020-1600-0c-e1561575930679.jpg'
                ],
                combustivel: 'Elétrico',
                arCondicionado: true,
                quatroPortas: true,
                preço: 230
            }
        }
    

    },
]